// Thin os-core wrapper around the @os/hr web page. Routed from App.tsx
// at /workspace/hr.
import HrIndexPage from '@os/hr/web/pages/HrIndexPage'

export default function HrWorkspacePage() {
  return <HrIndexPage />
}
